import { render } from "./ManageFreeInventory.vue?vue&type=template&id=5921f48a&scoped=true"
import script from "./ManageFreeInventory.vue?vue&type=script&lang=js"
export * from "./ManageFreeInventory.vue?vue&type=script&lang=js"

import "./ManageFreeInventory.vue?vue&type=style&index=0&id=5921f48a&scoped=true&lang=css"
import "./ManageFreeInventory.vue?vue&type=style&index=1&id=5921f48a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5921f48a"]])

export default __exports__